import { useAppSelector } from "@/store/hooks";
import { useEffect, useMemo, useState } from "react";

const useBusiness = () => {
  const user = useAppSelector((state) => state.auth.user);
  const [business, setBusiness] = useState<any>(null);
  const businessId = useMemo(() => business?.id, [business]);

  useEffect(() => {
    if (user && !business) {
      setBusiness(user.business);
    }
  }, [user]);

  return { business, businessId, setBusiness };
};

export default useBusiness;
